import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';
import mainRoutes from 'routes/mainRoutes';
import AuthContainer from 'containers/AuthContainer';
import UserLayout from 'layouts/UserLayout';

const LayoutWrapper = observer(() => {
  const getLayout = (element: JSX.Element) => {
    return <UserLayout>{element}</UserLayout>;
  };

  return (
    <div style={{ height: '100%' }}>
      <Routes>
        {mainRoutes.map((route, index: number) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <AuthContainer isPublic={route.isPublic} title={route.name}>
                  <>{getLayout(<route.element />)}</>
                </AuthContainer>
              }
            />
          );
        })}
      </Routes>
    </div>
  );
});

export default LayoutWrapper;
